

/**

 * @param {string} str
 * @returns {string}
 */
export function toTitleCase(str) {
    if (typeof str !== 'string') {
      return str; // If it's not a string, return the original value
    }
  
    return str
      .toLowerCase()
      // .replace(/[^a-zA-Z0-9 ]/g, '') // Remove special characters
      .split(' ')
      .map(word =>
        word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(' ');
  }
  